import { render, staticRenderFns } from "./productAttributeStyle.vue?vue&type=template&id=5e5a44d6&scoped=true"
import script from "./productAttributeStyle.vue?vue&type=script&lang=js"
export * from "./productAttributeStyle.vue?vue&type=script&lang=js"
import style0 from "./productAttributeStyle.vue?vue&type=style&index=0&id=5e5a44d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a44d6",
  null
  
)

export default component.exports